import React from 'react';
import GenericSectionDashboard from '../GenericSectionDashboard';

const AdminSectionDashboard = () => (
  <GenericSectionDashboard
    sectionName="Admin Section"
    sectionId="admin-section"
    sectionKey="Admin Section"
    description="Parcels & documents received for Admin"
    backRoute="/"
  />
);

export default AdminSectionDashboard;
